import React from 'react'
import {connect} from 'react-redux'
import {change as changeFieldValue, reduxForm} from 'redux-form';
import {Link} from 'react-router-dom';
import iconeTicket from '../../img/ticket-perforated-fill.svg';

export class Empresa extends React.Component {
    selecionarEmpresa(empresa) {
        this.props.changeFieldValue('formularioCadastroEmpresa',
            'codigoEmpresa', empresa.id);
        this.props.changeFieldValue('formularioCadastroEmpresa',
            'razaoSocial', empresa.nome);
        this.props.changeFieldValue('formularioCadastroEmpresa',
            'email', empresa.email);
        this.props.changeFieldValue('formularioCadastroEmpresa',
            'urlImagem', empresa.urlImagem);
        this.props.changeFieldValue('formularioCadastroEmpresa',
            'mensagemAvisoBilhete', empresa.mensagemAvisoBilhete);
        this.props.changeFieldValue('formularioCadastroEmpresa',
            'tempoVisualizacaoDados', empresa.tempoVisualizacaoDados);
        this.props.changeFieldValue('formularioCadastroEmpresa',
            'avaliacaoEmpresa', empresa.notaEmpresa != null ? Number(empresa.notaEmpresa).toFixed(1) : '0.0');

        if (empresa.grupo) {
            this.props.changeFieldValue('formularioCadastroEmpresa',
                'grupo', {label: empresa.grupo, value: empresa.grupo});

        }
        if (empresa.endereco) {

            this.props.changeFieldValue('formularioCadastroEmpresa',
                'cep', empresa.endereco.cep);

            this.props.changeFieldValue('formularioCadastroEmpresa',
                'idEndereco', empresa.endereco.id);

            this.props.changeFieldValue('formularioCadastroEmpresa',
                'logradouro', empresa.endereco.logradouro);

            this.props.changeFieldValue('formularioCadastroEmpresa',
                'complemento', empresa.endereco.complemento);

            this.props.changeFieldValue('formularioCadastroEmpresa',
                'bairro', empresa.endereco.bairro);

            this.props.changeFieldValue('formularioCadastroEmpresa',
                'localidade', empresa.endereco.localidade);

            this.props.changeFieldValue('formularioCadastroEmpresa',
                'uf', empresa.endereco.uf);

            this.props.changeFieldValue('formularioCadastroEmpresa',
                'numero', empresa.endereco.numero);
        }


        this.props.changeFieldValue('formularioCadastroEmpresa',
            'cnpj', empresa.cnpj);

        this.props.changeFieldValue('formularioCadastroEmpresa',
            'nomeFantasia', empresa.nomeFantasia);

        this.props.changeFieldValue('formularioCadastroEmpresa',
            'nomeDono', empresa.nomeDono);

        this.props.changeFieldValue('formularioCadastroEmpresa',
            'telefoneDono', empresa.telefoneDono);

        this.props.changeFieldValue('formularioCadastroEmpresa',
            'nomeSocio', empresa.nomeSocio);

        this.props.changeFieldValue('formularioCadastroEmpresa',
            'telefoneSocio', empresa.telefoneSocio);

        this.props.changeFieldValue('formularioCadastroEmpresa',
            'nomeGerente', empresa.nomeGerente);

        this.props.changeFieldValue('formularioCadastroEmpresa',
            'telefoneGerente', empresa.telefoneGerente);

        this.props.changeFieldValue('formularioCadastroEmpresa',
            'opcoesTrechoAlternativo', empresa.opcoesTrechoAlternativo);
        this.props.changeFieldValue('formularioCadastroEmpresa',
            'habilitadoEncomenda', empresa.habilitadoEncomenda);

        this.props.changeFieldValue('formularioCadastroEmpresa',
            'multaRemarcacaoCancelamentoForaPrazo', empresa.multaRemarcacaoCancelamentoForaPrazo);

        this.props.changeFieldValue('formularioCadastroEmpresa',
            'multaRemarcacaoCancelamentoDentroPrazo', empresa.multaRemarcacaoCancelamentoDentroPrazo);

        if (empresa.telefones !== undefined && empresa.telefones.length > 0) {
            this.props.changeFieldValue('formularioCadastroEmpresa',
                'telefoneEmpresa', empresa.telefones[0]);
        }

        this.props.changeFieldValue('formularioCadastroEmpresa',
            'ie', empresa.ie);

        this.props.changeFieldValue('formularioCadastroEmpresa',
            'im', empresa.im);

        this.props.changeFieldValue('formularioCadastroEmpresa',
            'cnae', empresa.cnae);

        this.props.changeFieldValue('formularioCadastroEmpresa',
            'tar', empresa.tar);

        this.props.changeFieldValue('formularioCadastroEmpresa',
            'habilitadoBpe', empresa.habilitadoBpe);

        this.props.changeFieldValue('formularioCadastroEmpresa',
            'habilitadoBpeSites', empresa.habilitadoBpeSites);

        this.props.changeFieldValue('formularioCadastroEmpresa',
            'habilitadoSite', empresa.habilitadoSite);

        this.props.changeFieldValue('formularioCadastroEmpresa',
            'habilitadaVendaSeguro', empresa.habilitadaVendaSeguro);

        this.props.changeFieldValue('formularioCadastroEmpresa',
            'habilitadoBuscaReservaComBpe', empresa.habilitadoBuscaReservaComBpe);

        this.props.changeFieldValue('formularioCadastroEmpresa',
            'dataIniciaoVigenciaBuscaReservaComBpe', empresa.dataIniciaoVigenciaBuscaReservaComBpe);

        this.props.changeFieldValue('formularioCadastroEmpresa',
            'nomeSite', empresa.nomeSite);

        this.props.changeFieldValue('formularioCadastroEmpresa',
            'nomeCertificado', empresa.nomeCertificado);

        this.props.changeFieldValue('formularioCadastroEmpresa',
            'habilitadoAgencia', empresa.habilitadoAgencia);

        this.props.changeFieldValue('formularioCadastroEmpresa',
            'habilitadoAntt', empresa.habilitadoValorAntt);

        this.props.changeFieldValue('formularioCadastroEmpresa',
            'impostoPraticar', empresa.impostoPraticar ? empresa.impostoPraticar : '00.00');

        this.props.changeFieldValue('formularioCadastroEmpresa',
            'comissaoPraticar', empresa.comissaoPraticar ? empresa.comissaoPraticar : '00.00');

        this.props.changeFieldValue('formularioCadastroEmpresa',
            'agenteTipoUm', empresa.agenteTipoUm ? empresa.agenteTipoUm : '00.00');

        this.props.changeFieldValue('formularioCadastroEmpresa',
            'agenteTipoDois', empresa.agenteTipoDois ? empresa.agenteTipoDois : '00.00');

        this.props.changeFieldValue('formularioCadastroEmpresa',
            'agenteTipoTres', empresa.agenteTipoTres ? empresa.agenteTipoTres : '00.00');
        
        this.props.changeFieldValue('formularioCadastroEmpresa',
            'rodoviaria', empresa.rodoviaria);

        this.props.changeFieldValue('formularioCadastroEmpresa',
            'turismo', empresa.turismo);

        this.props.changeFieldValue('formularioCadastroEmpresa',
            'senhaAntt', empresa.turismo ? '********' : '');

        this.props.changeFieldValue('formularioCadastroEmpresa',
            'habilitadoEnvioWpp', empresa.habilitadoEnvioWpp);

        this.props.changeFieldValue('formularioCadastroEmpresa',
            'numeroNotaCte', empresa.numeroNotaCte);
        
        this.props.changeFieldValue('formularioCadastroEmpresa',
            'numeroNotaCteOs', empresa.numeroNotaCteOs);

        this.props.changeFieldValue('formularioCadastroEmpresa', 
            'habilitadoRegraBilhete', empresa.habilitadoRegraBilhete);
                    
        this.props.changeFieldValue('formularioCadastroEmpresa', 
            'tipoControleEmissaoBpe', empresa.tipoControleEmissaoBPe.valor);

        this.props.changeFieldValue('formularioCadastroEmpresa',
            'logomarca', empresa.logomarca);

        this.props.handleCheckedRegraConexaoTrecho(empresa.habilitadoRegraConexaoTrecho);

        if (empresa.endereco.nomeCidade !== null) {
            const cidadeDeOrigem = {
                id: empresa.endereco.codigoCidade,
                nome: empresa.endereco.nomeCidade,
                uf: empresa.endereco.uf
            };

            this.props.selecionarOrigem(cidadeDeOrigem);
            this.props.preencherSitesSelecionados(empresa.sites)
        }

        this.props.preencherEmpresaIntegracoesSelecionados(empresa.integracoes);

    }

    iconeBloqueioDesbloqueio() {
        if (this.props.empresa.bloqueada) {
            return <i className="material-icons nav-icon">&#xe899;</i>
        }
        return <i className="material-icons nav-icon">&#xe898;</i>
    }

    montarLinkPainelConfiguracao(empresa) {
        return `/painel-configuracao-bpe?codigoEmpresa=${empresa.id}&habilitadaBPe=${empresa.habilitadoBpe}&pagina=empresa`
    }

    montarLinkPainelConfiguracaoBilhete(empresa) {
        return `/painel-configuracao-bilhete?codigoEmpresa=${empresa.id}&pagina=empresa`
    }

    render() {
        return (
            <div className="geral">
                <div className="resumo">
                    <div className="row">
                        <div className="col-12 col-sm-2 col-md-2 col-lg-2 col-xl-2">
                            <span className="titulo-mobile">Razão social:&nbsp;</span>{this.props.empresa.nome}
                        </div>
                        <div className="col-12 col-sm-2 col-md-2 col-lg-2 col-xl-2">
                            <span className="titulo-mobile">Nome fantasia:&nbsp;</span>{this.props.empresa.nomeFantasia}
                        </div>
                        <div className="col-12 col-sm-2 col-md-2 col-lg-2 col-xl-2">
                            <span className="titulo-mobile">CNPJ/CPF:&nbsp;</span>{this.props.empresa.cnpj}
                        </div>
                        <div className="col-12 col-sm-2 col-md-2 col-lg-2 col-xl-2" style={{overflowWrap: 'break-word'}}>
                            <span className="titulo-mobile">E-mail:&nbsp;</span>{this.props.empresa.email}
                        </div>
                        <div className="col-12 col-sm-2 col-md-2 col-lg-2 col-xl-2">
                            <span className="titulo-mobile">Data de criação:&nbsp;</span>{this.props.empresa.dataCriacao}
                        </div>

                        <div className="col-12 col-sm-2 col-md-2 col-lg-2 col-xl-2">
                            <div className="acoes">
                                <div className="botoes">
                                    <button type="button" className="btn btn-excluir"
                                            data-toggle="modal" id={`btn-excluir-empresa${this.props.empresa.id}`}
                                            data-target="#modalConfirmacaoExclusaoEmpresa"
                                            onClick={() => this.props.selecionarEmpresa(this.props.empresa)}>
                                        <i className="material-icons nav-icon">&#xe872;</i>
                                    </button>
                                    <button type="button" className="btn btn-editar"
                                            data-toggle="modal"
                                            data-target="#modalCadastrarEmpresa"
                                            onClick={() => {this.selecionarEmpresa(this.props.empresa)
                                            this.props.selecionarEmpresa(this.props.empresa)}}>
                                        <i className="material-icons nav-icon">&#xe150;</i>
                                    </button>
                                    <button type="button" className="btn btn-editar"
                                            data-toggle="modal"
                                            data-target="#modalImpostoEmpresa"
                                            onClick={() => {
                                                this.props.buscarImpostoEmpresa(this.props.empresa.id)
                                                this.props.selecionarEmpresa(this.props.empresa)
                                            }
                                            }>
                                        <i className="material-icons nav-icon">&#xe85c;</i>
                                    </button>
                                    <button type="button" className="btn btn-excluir"
                                            data-toggle="modal"
                                            title={`${this.props.empresa.bloqueada ? 'Desbloquear empresa' : 'Bloquear empresa'}`}
                                            data-target="#modalConfirmacaoBloqueioEmpresa"
                                            onClick={() => {
                                                this.props.selecionarEmpresa(this.props.empresa)
                                            }}>
                                        {this.iconeBloqueioDesbloqueio()}
                                    </button>
                                    <Link to={this.montarLinkPainelConfiguracao(this.props.empresa)}
                                          className="btn btn-editar">
                                        <i className="material-icons nav-icon"
                                           onClick={() => this.props.selecionarEmpresa(this.props.empresa)}>&#xe8a4;
                                        </i>
                                    </Link>
                                    <Link to={this.montarLinkPainelConfiguracaoBilhete(this.props.empresa)}>
                                    <img style={{cursor: 'pointer'}} title='Ticket'  className='btn btn-editar material-icons nav-icon'
                                                src={iconeTicket} />
                                    </Link>                                    
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default connect(null, {changeFieldValue})(reduxForm({
    form: 'formularioCadastroEmpresa'
})(Empresa))
